import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function Billing() {
    const [params] = useSearchParams();
    const sessionId = params.get("session_id");
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const [status, setStatus] = useState("checking");
    const polling = useRef(0);

    useEffect(() => {
        if (!sessionId) {
            navigate("/app/forfait");
            return;
        }
        const tick = async () => {
            try {
                const { data } = await api.get(`/payments/checkout/status/${sessionId}`);
                if (data.payment_status === "paid") {
                    setStatus("paid");
                    refresh?.();
                    return;
                }
                if (data.status === "expired") {
                    setStatus("expired");
                    return;
                }
                polling.current += 1;
                if (polling.current > 8) {
                    setStatus("timeout");
                    return;
                }
                setTimeout(tick, 2000);
            } catch {
                setStatus("error");
            }
        };
        tick();
    }, [sessionId, navigate, refresh]);

    return (
        <div className="max-w-md mx-auto px-6 sm:px-8 pt-16">
            <div className="tk-card p-10 text-center" data-testid="billing-result">
                {status === "checking" && (
                    <>
                        <Loader2 className="w-12 h-12 text-[#007AFF] mx-auto mb-4 animate-spin" />
                        <h1 className="text-2xl font-semibold tracking-tight text-[#1D1D1F]">Vérification du paiement…</h1>
                        <p className="mt-2 text-[#86868B]">Quelques secondes seulement.</p>
                    </>
                )}
                {status === "paid" && (
                    <>
                        <CheckCircle2 className="w-14 h-14 text-[#34C759] mx-auto mb-4" />
                        <h1 className="text-2xl font-semibold tracking-tight text-[#1D1D1F]">Paiement réussi !</h1>
                        <p className="mt-2 text-[#86868B]">Votre plan est désormais actif.</p>
                        <button onClick={() => navigate("/app")} className="tk-btn tk-btn-primary mt-6" data-testid="billing-continue">
                            Aller au tableau de bord
                        </button>
                    </>
                )}
                {(status === "expired" || status === "timeout" || status === "error") && (
                    <>
                        <XCircle className="w-14 h-14 text-[#FF3B30] mx-auto mb-4" />
                        <h1 className="text-2xl font-semibold tracking-tight text-[#1D1D1F]">Paiement non confirmé</h1>
                        <p className="mt-2 text-[#86868B]">Réessayez ou contactez le support.</p>
                        <button onClick={() => navigate("/app/forfait")} className="tk-btn tk-btn-secondary mt-6">
                            Retour aux réglages
                        </button>
                    </>
                )}
            </div>
        </div>
    );
}
